import { createReducer } from '@common/redux-utils';
import {
  RealEstateAgentActionType,
  RealEstateAgentToggleViewOnlyAction,
  RealEstateAgentSearchFailureAction,
  RealEstateAgentSearchSuccessAction,
  GetRealEstateAgentTypesStartAction,
  GetRealEstateAgentTypesSuccessAction,
  GetRealEstateAgentTypesFailureAction,
  GetRealEstateAgentRatingsStartAction,
  GetRealEstateAgentRatingsSuccessAction,
  GetRealEstateAgentRatingsFailureAction,
  GetRealEstateAgentStatusesStartAction,
  GetRealEstateAgentStatusesSuccessAction,
  GetRealEstateAgentStatusesFailureAction,
  CreateRealEstateAgentFailureAction,
  CreateRealEstateAgentStartAction,
  CreateRealEstateAgentSuccessAction,
  EditRealEstateAgentFailureAction,
  EditRealEstateAgentStartAction,
  EditRealEstateAgentSuccessAction,
  GetRealEstateAgentContractsFailureAction,
  GetRealEstateAgentContractsStartAction,
  GetRealEstateAgentContractsSuccessAction,
  // GetRealEstateAgentFailureAction,
  // GetRealEstateAgentStartAction,
  GetRealEstateAgentSuccessAction,
  RealEstateAgentSearchStartAction,
  RealEstateAgentOfficeCacheFetchNewOfficeStartAction,
  RealEstateAgentOfficeCacheFetchNewOfficeSuccessAction,
  RealEstateAgentOfficeCacheFetchNewOfficeFailureAction
} from './realestate-agent.actions';
import { RealEstateAgentViewModel, AgentSearchViewModel } from '@models/RealEstateAgent';
import { RealEstateOfficeViewModel } from '@models/RealEstateOffice';
import { ContractSimpleViewModel } from '@models/Contract';
import { PageViewModel, OptionsViewModel } from '@models/common.models';
import { RealEstateAgentSetOfficeAction } from './realestate-agent.actions';

export interface RealEstateAgentState {
  readonly errorMessage?: string;
  readonly id?: number;
  readonly isViewOnly: boolean;
  readonly viewOnlyContracts?: PageViewModel<ContractSimpleViewModel>;
  readonly saving?: boolean;
  readonly query?: string | null;
  readonly realEstateAgentLoading?: boolean;
  readonly realEstateAgentPageCount?: number;
  readonly realEstateAgentPageNumber?: number;
  readonly realEstateAgentPageSize?: number;
  readonly realEstateAgentOrderBy?: string;
  readonly realEstateAgents?: AgentSearchViewModel[];
  readonly realEstateAgentOfficeCache: { [property: string]: RealEstateOfficeViewModel };
  readonly realEstateAgentTotalResults?: number;

  readonly realEstateAgentTypes: Array<OptionsViewModel>;
  readonly realEstateAgentRatings: Array<OptionsViewModel>;
  readonly realEstateAgentStatuses: Array<OptionsViewModel>;
  readonly loadingAgentIds: number[];
  readonly loadedComponentAgent?: RealEstateAgentViewModel;
  readonly loadedAgentOffice?: RealEstateOfficeViewModel;
}

// This is the initial state of the page
const initialState: RealEstateAgentState = {
  errorMessage: '',
  isViewOnly: true,
  realEstateAgentOfficeCache: {},
  realEstateAgentTypes: [],
  realEstateAgentRatings: [],
  realEstateAgentStatuses: [],
  loadingAgentIds: []
};

function handleCreateRealEstateAgentStart(
  state: RealEstateAgentState,
  action: CreateRealEstateAgentStartAction
): RealEstateAgentState {
  return {
    ...state,
    saving: true
  };
}

function handleCreateRealEstateAgentSuccess(
  state: RealEstateAgentState,
  action: CreateRealEstateAgentSuccessAction
): RealEstateAgentState {
  return {
    ...state,
    saving: false,
    id: action.createdID
  };
}

function handleCreateRealEstateAgentFailure(
  state: RealEstateAgentState,
  action: CreateRealEstateAgentFailureAction
): RealEstateAgentState {
  return {
    ...state,
    saving: false,
    errorMessage: action.errorMessage || ''
  };
}

function handleEditRealEstateAgentStart(
  state: RealEstateAgentState,
  action: EditRealEstateAgentStartAction
): RealEstateAgentState {
  return {
    ...state
  };
}

function handleEditRealEstateAgentSuccess(
  state: RealEstateAgentState,
  action: EditRealEstateAgentSuccessAction
): RealEstateAgentState {
  return {
    ...state,
    saving: false,
    id: action.createdID
    // errorMessage: 'SUCCESS - agent saved - ID: ' + action.createdID
  };
}

function handleEditRealEstateAgentFailure(
  state: RealEstateAgentState,
  action: EditRealEstateAgentFailureAction
): RealEstateAgentState {
  return {
    ...state,
    errorMessage: action.errorMessage || ''
  };
}

function handleRealEstateAgentToggleViewOnly(state: RealEstateAgentState, action: RealEstateAgentToggleViewOnlyAction) {
  return {
    ...state,
    isViewOnly: !state.isViewOnly
  };
}

function handleRealEstateAgentGetContractsStart(
  state: RealEstateAgentState,
  action: GetRealEstateAgentContractsStartAction
) {
  return state;
}

function handleRealEstateAgentGetContractsSuccess(
  state: RealEstateAgentState,
  action: GetRealEstateAgentContractsSuccessAction
) {
  return {
    ...state,
    viewOnlyContracts: action.contracts
  };
}

function handleRealEstateAgentGetContractsFail(
  state: RealEstateAgentState,
  action: GetRealEstateAgentContractsFailureAction
) {
  return state;
}

function handleGetRealEstateAgentTypesStart(state: RealEstateAgentState, action: GetRealEstateAgentTypesStartAction) {
  return {
    ...state
    // message: action.message
  };
}

function handleGetRealEstateAgentTypesSuccess(
  state: RealEstateAgentState,
  action: GetRealEstateAgentTypesSuccessAction
) {
  return {
    ...state,
    // message: action.message,
    realEstateAgentTypes: action.realEstateAgentTypes
  };
}

function handleGetRealEstateAgentTypesFailure(
  state: RealEstateAgentState,
  action: GetRealEstateAgentTypesFailureAction
) {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetRealEstateAgentRatingsStart(
  state: RealEstateAgentState,
  action: GetRealEstateAgentRatingsStartAction
) {
  return {
    ...state
    // message: action.message
  };
}

function handleGetRealEstateAgentRatingsSuccess(
  state: RealEstateAgentState,
  action: GetRealEstateAgentRatingsSuccessAction
) {
  return {
    ...state,
    // message: action.message,
    realEstateAgentRatings: action.realEstateAgentRatings
  };
}

function handleGetRealEstateAgentRatingsFailure(
  state: RealEstateAgentState,
  action: GetRealEstateAgentRatingsFailureAction
) {
  return {
    ...state,
    message: action.errorMessage
  };
}

function handleGetRealEstateAgentStatusesStart(
  state: RealEstateAgentState,
  action: GetRealEstateAgentStatusesStartAction
) {
  return {
    ...state
    // message: action.message
  };
}

function handleGetRealEstateAgentStatusesSuccess(
  state: RealEstateAgentState,
  action: GetRealEstateAgentStatusesSuccessAction
) {
  return {
    ...state,
    // message: action.message,
    realEstateAgentStatuses: action.realEstateAgentStatuses
  };
}

function handleGetRealEstateAgentStatusesFailure(
  state: RealEstateAgentState,
  action: GetRealEstateAgentStatusesFailureAction
) {
  return {
    ...state,
    message: action.errorMessage
  };
}

/********** Search **********/
function handleRealEstateAgentSearchInit(
  state: RealEstateAgentState,
  action: RealEstateAgentSearchStartAction
): RealEstateAgentState {
  return {
    ...state,
    // message: 'Search Init',
    query: action.query,
    realEstateAgentLoading: true
  };
}
function handleRealEstateAgentSearchFailure(
  state: RealEstateAgentState,
  action: RealEstateAgentSearchFailureAction
): RealEstateAgentState {
  return {
    ...state,
    //  message: action.errorMessage,
    realEstateAgentLoading: false
  };
}
function handleRealEstateAgentSearchSuccess(
  state: RealEstateAgentState,
  action: RealEstateAgentSearchSuccessAction
): RealEstateAgentState {
  return {
    ...state,
    //  message: 'Search Success!',
    realEstateAgentLoading: false,
    realEstateAgentTotalResults: action.result.totalResults,
    realEstateAgentPageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    realEstateAgentPageNumber: action.pageNumber,
    realEstateAgentPageSize: action.pageSize,
    realEstateAgentOrderBy: action.orderBy,
    realEstateAgents: action.result.results
  };
}

function handleRealEstateAgentGetOfficeForCacheInit(
  state: RealEstateAgentState,
  action: RealEstateAgentOfficeCacheFetchNewOfficeStartAction
): RealEstateAgentState {
  return {
    ...state
  };
}

function handleRealEstateAgentAddOfficeToCache(
  state: RealEstateAgentState,
  action: RealEstateAgentOfficeCacheFetchNewOfficeSuccessAction
): RealEstateAgentState {
  let cache = state.realEstateAgentOfficeCache;
  const currentValue = cache[action.officeId];
  if (currentValue && currentValue.id === action.officeDetails.id) {
    // If a value already exists in the cache, and its ID matches the id we have to add
    return state;
  }

  cache = {
    ...cache,
    [action.officeId]: action.officeDetails
  };

  return {
    ...state,
    realEstateAgentOfficeCache: cache
  };
}

function handleRealEstateAgentGetOfficeForCacheFailure(
  state: RealEstateAgentState,
  action: RealEstateAgentOfficeCacheFetchNewOfficeFailureAction
): RealEstateAgentState {
  return {
    ...state
  };
}

function handleGetRealEstateAgentSuccess(
  state: RealEstateAgentState,
  action: GetRealEstateAgentSuccessAction
): RealEstateAgentState {
  return {
    ...state,
    loadedComponentAgent: action.loadedAgent
  };
}

function handleRealEstateAgentSetOffice(
  state: RealEstateAgentState,
  action: RealEstateAgentSetOfficeAction
): RealEstateAgentState {
  return {
    ...state,
    loadedAgentOffice: action.loadedOffice
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const RealEstateAgentReducer = createReducer(initialState, {
  [RealEstateAgentActionType.CreateRealEstateAgentStart]: handleCreateRealEstateAgentStart,
  [RealEstateAgentActionType.CreateRealEstateAgentSuccess]: handleCreateRealEstateAgentSuccess,
  [RealEstateAgentActionType.CreateRealEstateAgentFailure]: handleCreateRealEstateAgentFailure,
  [RealEstateAgentActionType.EditRealEstateAgentStart]: handleEditRealEstateAgentStart,
  [RealEstateAgentActionType.EditRealEstateAgentSuccess]: handleEditRealEstateAgentSuccess,
  [RealEstateAgentActionType.EditRealEstateAgentFailure]: handleEditRealEstateAgentFailure,

  [RealEstateAgentActionType.GetRealEstateAgentSuccess]: handleGetRealEstateAgentSuccess,

  [RealEstateAgentActionType.RealEstateAgentToggleViewOnly]: handleRealEstateAgentToggleViewOnly,

  [RealEstateAgentActionType.GetRealEstateAgentContractsStart]: handleRealEstateAgentGetContractsStart,
  [RealEstateAgentActionType.GetRealEstateAgentContractsSuccess]: handleRealEstateAgentGetContractsSuccess,
  [RealEstateAgentActionType.GetRealEstateAgentContractsFail]: handleRealEstateAgentGetContractsFail,

  [RealEstateAgentActionType.GetRealEstateAgentTypesStart]: handleGetRealEstateAgentTypesStart,
  [RealEstateAgentActionType.GetRealEstateAgentTypesSuccess]: handleGetRealEstateAgentTypesSuccess,
  [RealEstateAgentActionType.GetRealEstateAgentTypesFailure]: handleGetRealEstateAgentTypesFailure,

  [RealEstateAgentActionType.GetRealEstateAgentRatingsStart]: handleGetRealEstateAgentRatingsStart,
  [RealEstateAgentActionType.GetRealEstateAgentRatingsSuccess]: handleGetRealEstateAgentRatingsSuccess,
  [RealEstateAgentActionType.GetRealEstateAgentRatingsFailure]: handleGetRealEstateAgentRatingsFailure,

  [RealEstateAgentActionType.GetRealEstateAgentStatusesStart]: handleGetRealEstateAgentStatusesStart,
  [RealEstateAgentActionType.GetRealEstateAgentStatusesSuccess]: handleGetRealEstateAgentStatusesSuccess,
  [RealEstateAgentActionType.GetRealEstateAgentStatusesFailure]: handleGetRealEstateAgentStatusesFailure,

  [RealEstateAgentActionType.RealEstateAgentSearchStart]: handleRealEstateAgentSearchInit,
  [RealEstateAgentActionType.RealEstateAgentSearchSuccess]: handleRealEstateAgentSearchSuccess,
  [RealEstateAgentActionType.RealEstateAgentSearchFailure]: handleRealEstateAgentSearchFailure,

  [RealEstateAgentActionType.RealEstateAgentOfficeCacheFetchNewOfficeStart]: handleRealEstateAgentGetOfficeForCacheInit,
  [RealEstateAgentActionType.RealEstateAgentOfficeCacheFetchNewOfficeSuccess]: handleRealEstateAgentAddOfficeToCache,
  [RealEstateAgentActionType.RealEstateAgentOfficeCacheFetchNewOfficeFailure]: handleRealEstateAgentGetOfficeForCacheFailure,

  [RealEstateAgentActionType.RealEstateAgentSetOfficeAction]: handleRealEstateAgentSetOffice
});



// WEBPACK FOOTER //
// ./src/realestate-agent/realestate-agent.reducer.ts